import { ReactDatePickerCustomHeaderProps } from "react-datepicker";

export const DatePickerCustomHeader= ({
    date,
    decreaseMonth,
    increaseMonth,
}:ReactDatePickerCustomHeaderProps) => {
    return(
      <div className="custom-header">
        <button
          type="button"
          className="react-datepicker__navigation react-datepicker__navigation--previous"
          aria-label="Previous Month"
          onClick={decreaseMonth}
        >
          <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
            Previous Month
          </span>
        </button>
        <span className="react-datepicker__current-month">
          {`${date.getFullYear()}年 ${date.getMonth() + 1}月`}
        </span>
        <button
          type="button"
          className="react-datepicker__navigation react-datepicker__navigation--next"
          aria-label="Next Month"
          onClick={increaseMonth}
        >
          <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
            Next Month
          </span>
        </button>
      </div>
    );
  }